export default "__VITE_ASSET__DqWqVpGM__"